import React, { Component } from 'react'
import { Table } from 'hljd'
import columns from './column'
import { observer } from 'mobx-react'
import store from './store'
import { toJS } from 'mobx'

@observer
export default class extends Component {
  componentDidMount() {
    store.getList()
  }

  render() {
    const { list, pagination } = store
    return (
      <div>
        <Table
          dataSource={toJS(list)}
          columns={columns}
          pagination={pagination}
          onChange={store.setPage}
          rowKey={record => record.id}
        />
      </div>
    )
  }
}
